import LanguageIndicator from './LanguageIndicator';
export default LanguageIndicator;
